export default {
  currentFlow: "",
  currentApplicationId: null,
  emptyApplication: {
    "purchase-approval": {},
    "purchase-preapproval": {},
    "refinance-approval": {},
    "switch-transfer": {}
  },
  clients: {},
  applications: {
    byId: {},
    allIds: []
  },
  currentPage: "",
  calculations: [],
  emptyCalculatedValues: {
    loading: false,
    propertyValueIndexId: "P",
    propertyValue: 0,
    combinedLtv: 0,
    combinedGds: 0,
    combinedTds: null,
    downpaymentPercent: 0,
    downpaymentAmount: 0,
    requestedMortgagePayments: null,
    totalDownpaymentAmount: 0,
    legend: {
      gds: [{
        name: "Employment and Other Income",
        value: 0,
        type: "income",
        $key_name: "calculators.EMPLOYMENT_AND_OTHER_INCOME"
      }, {
        name: "Existing Mortgage Payments",
        value: 0,
        type: "expense",
        $key_name: "calculators.EXISTING_MORTGAGE_PAYMENTS"
      }, {
        name: "Requested Mortgage Payments",
        value: null,
        type: "expense",
        $key_name: "calculators.REQUESTED_MORTGAGE_PAYMENTS"
      }, {
        name: "Subject Property Expenses",
        value: 0,
        type: "expense",
        $key_name: "calculators.SUBJECT_PROPERTY_EXPENSES"
      }, {
        name: "Subject Property Rental Income",
        value: 0,
        type: "income",
        $key_name: "calculators.SUBJECT_PROPERTY_RENTAL_INCOME"
      }, {
        name: "Subject Property Rental Income Offset",
        value: 0,
        type: "expense",
        $key_name: "calculators.SUBJECT_PROPERTY_RENTAL_INCOME_OFFSET"
      }],
      tds: [{
        name: "Employment and Other Income",
        value: 0,
        type: "income",
        $key_name: "calculators.EMPLOYMENT_AND_OTHER_INCOME"
      }, {
        name: "Existing Mortgage Payments",
        value: 0,
        type: "expense",
        $key_name: "calculators.EXISTING_MORTGAGE_PAYMENTS"
      }, {
        name: "Requested Mortgage Payments",
        value: null,
        type: "expense",
        $key_name: "calculators.REQUESTED_MORTGAGE_PAYMENTS"
      }, {
        name: "Subject Property Expenses",
        value: 0,
        type: "expense",
        $key_name: "calculators.SUBJECT_PROPERTY_EXPENSES"
      }, {
        name: "Subject Property Rental Income",
        value: 0,
        type: "income",
        $key_name: "calculators.SUBJECT_PROPERTY_RENTAL_INCOME"
      }, {
        name: "Subject Property Rental Income Offset",
        value: 0,
        type: "expense",
        $key_name: "calculators.SUBJECT_PROPERTY_RENTAL_INCOME_OFFSET"
      }, {
        name: "Liabilities",
        value: 0,
        type: "expense",
        $key_name: "calculators.LIABILITIES"
      }, {
        name: "Other Properties Existing Mortgage Payments",
        value: 0,
        type: "expense",
        $key_name: "calculators.OTHER_PROPERTIES_EXISTING_MORTGAGE_PAYMENTS"
      }, {
        name: "Other Properties Expenses",
        value: 0,
        type: "expense",
        $key_name: "calculators.OTHER_PROPERTIES_EXPENSES"
      }, {
        name: "Other Properties Rental Income",
        value: 0,
        type: "income",
        $key_name: "calculators.OTHER_PROPERTIES_RENTAL_INCOME"
      }, {
        name: "Other Properties Rental Income Offset",
        value: 0,
        type: "expense",
        $key_name: "calculators.OTHER_PROPERTIES_RENTAL_INCOME_OFFSET"
      }],
      ltv: [{
        name: "Property Value",
        value: 0,
        $key_name: "calculators.PROPERTY_VALUE"
      }, {
        name: "Mortgages Amount",
        value: 0,
        $key_name: "calculators.MORTGAGES_AMOUNT"
      }, {
        name: "LTV Ratio",
        value: 0,
        $key_name: "calculators.LTV_RATIO"
      }]
    },
    mortgageValues: [{
      pAndIPaymentAmountMonthly: null,
      pAndIPaymentAmount: null,
      netLoanAmount: 0,
      totalLoanAmount: 0,
      gds: 0,
      tds: null,
      ltv: 0,
      balanceRemaining: 0,
      interestAdjustmentAmount: 0,
      miPremiumAmount: 0,
      miPremiumRate: 0,
      miPremiumPst: 0,
      pAndIPaymentAmountQualify: null,
      pAndIPaymentFrequencyQualify: null,
      qualifyingGds: 0,
      qualifyingTds: null,
      netRate: 0,
      qualifyingNetRate: 0,
      mortgageType: "first",
      totalInterest: null,
      paymentsInTerm: 0,
      balanceAverage: null,
      interestFactor: 0,
      term: 0
    }],
    monthlyEmploymentIncome: 0,
    monthlyAdditionalIncome: 0,
    monthlyLiabilities: 0,
    totalAssets: 0
  },
  calculatedValues: {
    loading: false
  },
  clientRequestEmail: "",
  requestDataEmail: "",
  requestDataName: "",
  schema: {
    metadata: {},
    "purchase-approval": [],
    "purchase-preapproval": [],
    "refinance-approval": [],
    "switch-transfer": []
  },
  customizationSchema: {},
  eSign: {
    availableDocuments: {
      byId: {},
      allIds: []
    },
    selectedDocuments: [],
    clientApplicationRequests: {
      byId: {},
      allIds: []
    },
    templates: {
      byId: {},
      allIds: []
    }
  },
  filogix: {
    pendingSubmissions: {
      byApplication: {}
    },
    submissions: {
      byApplication: {}
    },
    updatingSyncStatus: {
      byApplication: {
        // intervalId: null,
        // previousLoadStatus: null,
        // loading: false
      }
    }
  },
  mutedAutomations: {
    byApplication: {}
  },
  requestedPackages: {
    byApplication: {}
  },
  commissions: {
    currentCommissionsMortgageType: "",
    fees: {
      byApplication: {}
    },
    deductions: {
      byApplication: {}
    },
    deductionStructure: {
      mortgageType: "",
      commissionsDeductionId: "",
      type: "",
      amount: 0,
      fundsReceived: "",
      description: ""
    },
    commissionDetails: {
      byApplication: {}
    },
    notes: {
      byApplication: {}
    }
  },
  applicationValidations: {},
  generatedLenderNote: "",
  waitingForGeneratedLenderNote: false,
  insuranceSubmissionsHistory: [],
  insuranceProviders: []
};